import { render, staticRenderFns } from "./diagram-kebab-menu.vue?vue&type=template&id=abffb72a&scoped=true"
import script from "./diagram-kebab-menu.vue?vue&type=script&lang=js"
export * from "./diagram-kebab-menu.vue?vue&type=script&lang=js"
import style0 from "./diagram-kebab-menu.vue?vue&type=style&index=0&id=abffb72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abffb72a",
  null
  
)

export default component.exports